import api from '@/api/index.js'

const reporting_profile = {
  state: {
    loading: false,
    updating: false,
    profile: null,
    createdProfile: {
      id: '',
      name: ''
    },
    error: null,
  },

  mutations: {
    SET_REPORTING_PROFILE: (state, profile) => {
      state.profile = profile
    },
    SET_REPORTING_PROFILE_UPDATE: (state, profile) => {
      profile.accounts = state.profile.accounts
      state.profile = profile;
    },
    SET_REPORTING_PROFILE_ERROR: (state, error) => {
      state.error = error
    },
    SET_REPORTING_PROFILE_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_REPORTING_PROFILE_UPDATING: (state, loading) => {
      state.updating = loading
    },
    SET_CREATED_REPORTING_PROFILE: (state, createdProfile) => {
      state.createdProfile = createdProfile
    },
  },

  actions: {
    GetReportingProfile({commit}, id) {
      commit('SET_REPORTING_PROFILE_LOADING', true)
      return api.get(`reporting-profiles/${id}`)
        .then((response) => {
          commit('SET_REPORTING_PROFILE', response)
          commit('SET_REPORTING_PROFILE_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_REPORTING_PROFILE_LOADING', false)
        })
    },
    ResetReportingProfileError({commit}) {
      commit('SET_REPORTING_PROFILE_ERROR', null)
    },
    CreateReportingProfile({commit}, payload) {
      commit('SET_REPORTING_PROFILE_ERROR', null)
      commit('SET_CREATED_REPORTING_PROFILE', null)
      return api.post(`reporting-profiles`, payload)
        .then((response) => commit('SET_CREATED_REPORTING_PROFILE', response.body))
        .catch((error) => commit('SET_REPORTING_PROFILE_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText))
    },
    UpdateReportingProfile({commit}, payload) {
      let out = {...payload}
      out.accounts = null;
      commit('SET_REPORTING_PROFILE_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_REPORTING_PROFILE_UPDATING', true)
      return api.put(`reporting-profiles/${out.id}`, out)
        .then((response) => {
          commit('SET_REPORTING_PROFILE_UPDATE', response.body)
          commit('SET_REPORTING_PROFILE_UPDATING', false)
        })
        .catch((error) => commit('SET_REPORTING_PROFILE_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText))
    },
    DeleteReportingProfile({commit}, payload) {
      commit('SET_REPORTING_PROFILE_ERROR', null)
      return api.delete(`reporting-profiles/${payload.id}`)
        // .then((response) => commit('SET_REPORTING_PROFILE_ERROR', null))
        .catch((error) => {
          commit('SET_REPORTING_PROFILE_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    // wants payload with {"account_id": "UUID-HERE"} (UUID should be retrieved from account search)
    AddAccountToReportingProfile({commit}, payload) {
      commit('SET_REPORTING_PROFILE_ERROR', null)
      return api.post(`reporting-profiles/${payload.id}/accounts`, payload)
        .then((response) => commit('SET_ERROR', null))
        .catch((error) => commit('SET_REPORTING_PROFILE_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText))
    },
    DeleteAccountFromReportingProfile({commit}, payload) {
      commit('SET_REPORTING_PROFILE_ERROR', null)
      return api.delete(`reporting-profiles/${payload.profile_id}/accounts/${payload.id}`)
        .then((response) => commit('SET_ERROR', null))
        .catch((error) => {
          commit('SET_REPORTING_PROFILE_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  }
}

export default reporting_profile
